import React from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

interface Option {
  value: string;
  label: string;
}

interface SelectProps {
  options: { value: string; label: string }[];
  register: UseFormRegisterReturn;
  error?: FieldError;
  className?: string;
  labelName: string;
  required?: boolean; // Added `required` prop
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onFocus?: () => Promise<void>;
}

const SelectTag: React.FC<SelectProps> = ({
  options,
  register,
  error,
  className,
  labelName,
  required = false, // Set default to `false`
}) => {
  return (
    <div className="form-group mb-4 sm:mb-0">
      <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
        {labelName}
        <span className="font-[400]">
          {' '}
          { required ? '(Required)' : ''}
        </span>
      </label>
      <div className="relative">
        <select
          {...register}
          aria-required={required ? true : false}
          className={`form-control p-2 rounded mt-1 w-full ${className} ${
            error ? 'border-[#B91C1C] border-2' : 'border-gray-300 border'
          }`}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error && <span className="text-[#B91C1C]">{error.message}</span>}
      </div>
    </div>
  );
};

export default SelectTag;
